var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-a",
    d: "M53.907783,29.9998387 L53.907783,0.149854823 L57,0.149854823 L57,29.9998387 L53.907783,29.9998387 Z M23.474023,0.150016131 L26.8393189,0.150016131 L37.0942348,23.2113668 L47.5162107,0.150016131 L50.8815066,0.150016131 L37.4195199,30 L36.7464608,30 L23.474023,0.150016131 Z M15.3759485,1.77635684e-15 L29.8049557,29.8499839 L26.4653614,29.8499839 L21.5989347,20.0287665 L8.26947167,20.0287665 L3.44962906,29.8499839 L0,29.8499839 L14.6185561,1.77635684e-15 L15.3759485,1.77635684e-15 Z M14.9856063,6.34181095 L9.68385974,17.1470051 L20.2616513,17.1470051 L14.9856063,6.34181095 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#363A40",
    mask: "url(#logo-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ea8d681f.svg";
export { ForwardRef as ReactComponent };